// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { headerStyles } from "@sc/Overrides/Widgets/MyListsDetails/MyListsDetailsHeader";
import { displayFlexOnPrint, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

headerStyles.infoGridItem = {
    width: 12,
    css: css`
        align-items: flex-end;
        flex-wrap: wrap;
        column-gap: 30px;
        ${displayFlexOnPrint}
        @media print {
            justify-content: flex-start;
        }
        ${xScreen("lte", "sm")} {
            align-items: flex-start;
        }
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

headerStyles.tagsSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

headerStyles.tagsTitle = {
    forwardAs: "p",
    size: 14,
    lineHeight: "22px",
    weight: "normal",
    transform: "capitalize",
};

headerStyles.tagsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
    `,
};

headerStyles.tag = {
    css: css`
        margin: 0;
        border-radius: 13px;
        padding: 4px 8px;
    `,
};

headerStyles.descriptionStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 4px;
        `,
    },
    heading: {
        forwardAs: "p",
        size: 14,
        lineHeight: "22px",
        weight: "normal",
        transform: "capitalize",
    },
    text: {
        forwardAs: "p",
        size: 14,
        lineHeight: "22px",
    },
};

headerStyles.lastUpdateText = {
    as: "p",
    size: 14,
    color: "common.ui6",
};

headerStyles.totalLabel = {
    as: "p",
    size: 14,
    lineHeight: "22px",
};

headerStyles.totalText = {
    as: "p",
    size: 16,
    weight: "bold",
    color: "text",
};

headerStyles.totalVatLabelText = {
    size: 12,
    css: css`
        margin-left: 5px;
    `,
};

headerStyles.totalWithoutVatText = {
    weight: "bold",
    css: css`
        margin-left: 5px;
    `,
};

headerStyles.totalWithoutVatLabelText = {
    size: 12,
    css: css`
        margin-left: 5px;
    `,
};

headerStyles.totalWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        ${xScreen("lte", "sm")} {
            flex-direction: row;
            gap: 10px;
        }
    `,
};
headerStyles.noPriceMessage = {
    as: "p",
    size: 16,
    weight: "bold",
    color: "primary.main",
};
